"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperSubject = exports.WrapperStatusAd = exports.WrapperProductStatus = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var WrapperProductStatus = exports.WrapperProductStatus = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var WrapperSubject = exports.WrapperSubject = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n\n  font-size: var(--font-size-xs);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), function (_ref) {
  var adStatus = _ref.adStatus;
  return adStatus === 'active' && "\n      min-width: 100%;\n  ";
});
var WrapperStatusAd = exports.WrapperStatusAd = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: var(--spacing-0-5) var(--spacing-1);\n  background-color: var(--color-neutral-90);\n  color: var(--color-neutral-130);\n  font-size: var(--font-size-xxxs);\n  border-radius: var(--border-radius-xs);\n  font-weight: var(--font-weight-semibold);\n  margin-left: var(--spacing-0-5);\n\n  ", "\n"])), function (_ref2) {
  var isSelected = _ref2.isSelected;
  return isSelected && "\n      background-color: var(--color-neutral-100);\n  ";
});